import React from "react"

function IconMouseEmitSignal({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="mouse-emit-signal"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-mouse-emit-signal"
      {...props}
    >
      <path
        d="M16.364 7.855c.771 0 1.404.588 1.476 1.34l.007.143v6.425a5.79 5.79 0 0 1-5.294 5.766l-.243.016-.25.005a5.787 5.787 0 0 1-5.782-5.549l-.005-.238V9.338c0-.771.588-1.405 1.34-1.477l.143-.006h8.608zm.173 5.817H7.582v2.09a4.477 4.477 0 0 0 4.241 4.474l.222.005.22-.005a4.478 4.478 0 0 0 4.267-4.25l.006-.223v-2.091zm-5.133-4.509H7.756a.174.174 0 0 0-.165.12l-.01.055v3.025h3.823v-3.2zm4.96 0h-3.65v3.2h3.823V9.338a.174.174 0 0 0-.118-.166l-.055-.008zm-4.228-4.526a2.812 2.812 0 0 1 2.175 1.019.655.655 0 1 1-1.007.836 1.503 1.503 0 0 0-2.327.006.655.655 0 1 1-1.01-.833 2.813 2.813 0 0 1 2.17-1.028zm-.006-2.724a5.748 5.748 0 0 1 4.294 1.913.655.655 0 0 1-.973.876 4.437 4.437 0 0 0-6.628.016.655.655 0 0 1-.977-.872 5.746 5.746 0 0 1 4.284-1.933z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconMouseEmitSignal
